import { FileTextOutlined } from "@ant-design/icons"
import { Input } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { WorkspaceCard } from "../../../Lead/LeadWorkspacePage/cards/WorkspaceCard.tsx"
import { WorkspaceCardValue } from "../../../Lead/LeadWorkspacePage/cards/WorkspaceCardValue.tsx"
import { OverviewCardTitle } from "../../../Lead/LeadWorkspacePage/overview/OverviewCardIcon.tsx"
import type { Project, ProjectUpdateData } from "../../types/project.types.ts"

interface NotesCardValues {
  internal_notes: string | null
}

interface ProjectNotesCardProps {
  project: Project
  canEdit?: boolean
  onSave: (changed: Partial<ProjectUpdateData>) => Promise<boolean>
}

function ProjectNotesCard({ project, canEdit, onSave }: ProjectNotesCardProps) {
  const { t } = useTranslation()

  const values: NotesCardValues = {
    internal_notes: project?.internal_notes ?? null
  }

  return (
    <WorkspaceCard<NotesCardValues>
      cardId={"project-notes"}
      title={
        <OverviewCardTitle icon={<FileTextOutlined />} accent={"teal"}>
          {t("projectWorkspace.cards.notes.title")}
        </OverviewCardTitle>
      }
      ariaTitle={t("projectWorkspace.cards.notes.title")}
      className={"h-full"}
      canEdit={canEdit}
      values={values}
      onSave={onSave}
      renderEdit={({ values, setValues, saving }) => (
        <Input.TextArea
          autoFocus
          rows={6}
          disabled={saving}
          aria-label={t("projectWorkspace.cards.notes.title")}
          placeholder={t("projectWorkspace.cards.notes.placeholder")}
          value={values.internal_notes ?? ""}
          onChange={(event) =>
            setValues({ internal_notes: event.target.value || null })
          }
        />
      )}
    >
      <div
        className={
          "flex-1 min-h-[140px] rounded-lg border border-dashed border-border p-3"
        }
      >
        <WorkspaceCardValue
          value={project?.internal_notes}
          placeholder={t("projectWorkspace.cards.notes.empty")}
        />
      </div>
    </WorkspaceCard>
  )
}

export { ProjectNotesCard }
